import React, {useEffect, useState} from 'react'
import GiftList from '../views/GiftList'
import PairButtons from '../views/common/PairButtons'
import {getAd, getStore} from '../api'
import Loading from '../views/common/Loading'
import Header from '../views/common/Header'
import {Container} from '../styles/elements'
import Banner from "../views/Banner";

const useStore = () => {
  const [store, setStore] = useState()
  const [loading, setLoading] = useState()

  useEffect(() => {
    const getLoyaltyStore = async () => {
      setLoading(true)
      const loyaltyStore = await getStore()
      setStore(loyaltyStore)
      setLoading(false)
    }
    getLoyaltyStore()
  }, [])
  return [store, loading]
}

const useBanner = () => {
  const [banner, setBanner] = useState()
  useEffect(() => {
    const getBanner = async () => {
      const adsResponse = await getAd()
      setBanner(adsResponse.loyaltyClubBannerV2)
    }
    getBanner()
  }, [])
  return banner
}

export default ({loyalty: {status: {point}}}) => {
  const [store, loading] = useStore()
  const banner = useBanner();
  
  return (
    <>
      <Header score={point} onBack={() => window.parent.postMessage('onLoyaltyClosed', '*')}/>
      <Container>
        <PairButtons
          leftButton={{text: 'stars', invert: true, isIcon: true,}}
          rightButton={{text: 'purchases', invert: true, isIcon: true,}}
        />
        {banner && <Banner banner={banner}/>}
        {loading ?
          <Loading/> :
          store && store.categories.map((category, index) =>
            <GiftList
              key={index}
              point={point}
              isStore
              {...category}
            />
          )}
      </Container>
    </>
  )
}
